import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  position: number().required(),
  current_stage_id: string().required(),
});

/**
 * CardCreateEvent
 *
 * - Evento emitido quando um card é criado.
 */
export class CardCreateEvent extends CreateCommand(RealtimeEventType.CardCreate, SCHEMA) {}
